export const setUserData = (userdata: any) => ({
  type: "SET_USER_DATA",
  payload: { userdata },
});

export const setNotifications = (notifications: any) => ({
  type: "SET_NOTIFICATIONS",
  payload: { notifications },
});
